export default [
  {
    path: '/edit/question',
    name: "editQuestion",
    meta: {title: '编辑题目',barArr:[{name:'编辑题目',path:'/editQuestion'}]},
    component: () => import('@/views/question/edit_question.vue')
  },
]